const EMOJI: Record<string, string> = {
  bag: "👜",
  book: "📖",
  books: "📚",
  pencil: "✏️",
  ruler: "📏",
  key: "🔑",
  box: "📦",
  apple: "🍎",
  banana: "🍌",
  sandwich: "🥪",
  biscuit: "🍪",
  water: "💧",
  juice: "🧃",
  table: "🪵",
  chair: "🪑",
  bed: "🛏️",
  door: "🚪",
  window: "🪟",
  shelf: "🗄️",
  "t-shirt": "👕",
  jumper: "🧥",
  coat: "🧥",
  hat: "🎩",
  shoes: "👟",
  boots: "👢",
  fox: "🦊",
  dog: "🐶",
  wolf: "🐺",
  fish: "🐟",
  frog: "🐸",
  leaf: "🍃",
  dolphin: "🐬",
  mia: "👧",
  ben: "👦",
  pip: "🧸",
  cat: "🐱",
  map: "🗺️",
  kite: "🪁",
  ball: "⚽",
  fan: "💨",
};

const FALLBACK = ["🌟", "🎈", "🌙", "🍀", "🧁", "🎀", "🌸", "🍋"];

export function wordEmoji(word: string): string {
  const key = word.toLowerCase();
  const known = EMOJI[key];
  if (known) return known;
  let n = 0;
  for (let i = 0; i < key.length; i += 1) n = (n + key.charCodeAt(i) * (i + 3)) % FALLBACK.length;
  return FALLBACK[n]!;
}

export function SceneCard({ word, caption, selected, onClick }: { word: string; caption?: string; selected?: boolean; onClick?: () => void }) {
  const inner = (
    <>
      <span className="scene-emoji" aria-hidden="true">{wordEmoji(word)}</span>
      {caption ? <span className="scene-caption">{caption}</span> : <span className="sr-only">{word}</span>}
    </>
  );
  if (!onClick) return <div className={`scene-card${selected ? " on" : ""}`}>{inner}</div>;
  return (
    <button type="button" className={`scene-card${selected ? " on" : ""}`} onClick={onClick} aria-pressed={selected}>
      {inner}
    </button>
  );
}
